<pas-button-round
  [color]="iconColor"
  [hidden]="isHidden"
  (click)="onEditClick()"
  icon="{{ iconEdit }}"
  size="small"></pas-button-round>

<pas-button-round
  [color]="iconColor"
  [hidden]="isHidden"
  (click)="onDeleteClick()"
  icon="{{ iconDelete }}"
  size="small"></pas-button-round>
